import { Version } from '@spri/version/version';
import packageJson from '../../../package.json';

export const SPRI_VERSION = new Version(packageJson.version).full;
